import * as yup from 'yup';

/* eslint-disable */
export default yup.object().shape({
  ncm:
    yup.string()
      .label('NCM')
      .required('NCM é obrigatório.')
      .min(3, 'NCM deve ter no mínimo três caracteres.')
      .max(255),
  ncmSeq:
    yup.string()
    .nullable(),
  empresa:
    yup.array().nullable().min(1, 'Pelo menos uma empresa é necessária para cadastrar um novo produto.'),
  nomeProduto:
    yup.string()
      .required('Descrição é obrigatória.')
      .label('nomeProduto')
      .uppercase(),
  codigoCliente:
    yup.string()
      .required('Código do cliente é obrigatório.')
      .label('codigoCliente')
      .uppercase(),
  nomeProduto:
    yup.string()
      .label('nomeProduto')
      .nullable(),
  codigoTrust:
      yup.string()
        .label('codigoTrust')
        .nullable(),
  descricao:
    yup.string()
      .required('Descrição detalhada é obrigatória.')
      .label('descricao')
      .min(3, 'Descrição deve ter no mínimo três caracteres.')
      .uppercase(),
  unidadeMedida:
    yup.string()
      .label('Unidade de medida')
      .nullable()
      .required('Unidade de medida é obrigatória.')
      .min(1, 'Unidade de medida deve ter no mínimo um caracter.')
      .max(255, 'Unidade de medida deve ter no máximo 255 caracteres.'),
  quantidade:
    yup.number('Quantidade é obrigatória')
      .label('Quantidade')
      .typeError('Quantidade é obrigatória')
      .required('Quantidade é obrigatória.')
      .positive(),
  valorUnitario:
    yup.number('Valor unitário é obrigatório')
      .label('Valor unitário')
      .nullable()
      .required('Valor unitário é obrigatório.')
      .positive('Valor unitário é obrigatório'),
  moeda:
    yup.string()
      .label('Moeda')
      .required('Moeda é obrigatória.'),
  _id: yup.lazy(value => value ? yup.string() : yup.string().default(null).nullable().strip()),
}).transform((value) => {
  return {
    descricao: value.DESCRICAO,
    nomeProduto: value.NOME_PRODUTO,
    codigoCliente: value.CODIGO_PRODUTO,
    codigoTrust: value.CODIGO_TRUST,
    moeda: value.MOEDA,
    ncm: value.NCM,
    ncmSeq: value.NCM_SEQ,
    empresa: value.empresa,
    quantidade: value.QUANTIDADE,
    unidadeMedida: value.UNIDADE_MEDIDA,
    valorUnitario: value.VALOR_UNITARIO || 0,
  }
});
